// tslint:disable:no-any (autogenerated)
import BaseRequest from '../../components/base/base-request';

class CustomizationRequests extends BaseRequest {
    // tslint:disable-next-line:typedef (autogenerated)
    private sources = {
        fetchStatic: '/portalStaticFiles/styles'
    };

    public async fetchStyles(): Promise<any> {
        try {
            const result = await this.rawRequest<any>(
                this.sources.fetchStatic,
                {},
                {
                    type: 'GET'
                }
            );
            if (typeof result === 'string') {
                return JSON.parse(result);
            } else {
                return result;
            }
        } catch (error) {
            console.warn('Unable to load styles');
            return {};
        }
    }
}

const request = new CustomizationRequests();
// tslint:disable-next-line:no-default-export (autogenerated)
export default request;
